export const PromiseSlug = 'hyundai-promise';

export function getHyundaiPromiseUrl(dealerSlug?: string): string {
    return `/${dealerSlug ? `${dealerSlug}/` : ''}${PromiseSlug}`;
}
